export default __webpack_public_path__ + "static/background-image-3691df19c77bf72b83ecc82fa22f95d1.gif";